import { API_ROUTE } from '@/features/backend/config'
import { fetchJSON } from '@/utils/http'
import { OpenAIRealTimeSessionResponse } from './types'

export const createVoiceChatSession = async (
  toolId: string,
  threadId: string,
) => {
  try {
    const response = await fetchJSON(
      `${API_ROUTE}/tools/${toolId}/inference/voice-chat/session`,
      {
        method: 'POST',
        body: JSON.stringify({ threadId }),
      },
    )
    return response as OpenAIRealTimeSessionResponse
  } catch (error) {
    console.error('Error creating voice chat session:', error)
    throw error
  }
}

export const endVoiceChatSession = async (sessionId: string) => {
  try {
    await fetchJSON(
      `${API_ROUTE}/tools/inference/voice-chat/session/${sessionId}`,
      {
        method: 'DELETE',
      },
    )
  } catch (error) {
    console.error('Error ending voice chat session:', error)
    throw error
  }
}
